import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface RetailerMultipleStores {
  hasEverHadMultipleStores: boolean;
  setRetailerMultipleStores: (retailer: Partial<IRetailer>) => void;
}

export const useZustandRetailerMultipleStores = create<RetailerMultipleStores>(
  (set) => ({
    hasEverHadMultipleStores: false,
    setRetailerMultipleStores: (retailer) => {
      set({
        hasEverHadMultipleStores: (
          retailer.multi_store_statuses ?? []
        ).includes(IRetailer.MultiStoreStatus.HAS_EVER_HAD_MULTIPLE_STORES),
      });
    },
  })
);

const useHasEverHadMultipleStoresControl = () => {
  const { hasEverHadMultipleStores } = useRetailerStore([
    "hasEverHadMultipleStores",
  ]);

  return { hasEverHadMultipleStores };
};

export const useHasEverHadMultipleStores = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandRetailerMultipleStores();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useHasEverHadMultipleStoresControl();
};
